import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from '../Icon';
import ClickableWrap from '../ClickableWrap';

import './styles.less';

const Alert = (props) => {
    const pAlertAttributes = {
        className: classNames({
            'p-alert': true,
            [`p-alert--${props.alertType}`]: props.alertType,
            [`p-alert--${props.size}`]: props.size,
            [props.className]: props.className
        }),
        role: 'alert',
        'data-cid': props.contentId
    };

    return (
        <div {...pAlertAttributes}>
            <div className="p-alert__text">
                <ClickableWrap url={props.url}>{props.text}</ClickableWrap>
            </div>
            {props.presByText ? (
                <ClickableWrap url={props.presByUrl}>
                    <div className="p-alert__presented-by-text">{props.presByText}</div>
                </ClickableWrap>
            ) : null}
            {props.isRemovable ? (
                <span className="p-alert__close">
                    <Icon icon="close" />
                </span>
            ) : null}
        </div>
    );
};

Alert.propTypes = {
    text: PropTypes.string.isRequired,
    alertType: PropTypes.oneOf([
        'breaking-news',
        'developing-story',
        'rightNow',
        'error',
        'disclaimer',
        'success',
        'informational',
        'helpful',
        'no-hitter',
        'live-look'
    ]).isRequired,
    url: PropTypes.string,
    presByText: PropTypes.string,
    presByUrl: PropTypes.string,
    className: PropTypes.string,
    size: PropTypes.oneOf(['sm']),
    isRemovable: PropTypes.bool,
    contentId: PropTypes.string
};

Alert.defaultProps = {
    isRemovable: false,
    url: undefined,
    presByText: undefined,
    presByUrl: undefined,
    className: undefined,
    size: undefined,
    contentId: undefined
};

export default Alert;
